import {Trans} from '@lingui/macro';
import {isUndefined, noop} from 'lodash';
import React, {FC} from 'react';

import {Skeleton, SkeletonColorSchemesEnum} from '../../../components/common/skeleton';
import {OauthClientModel} from '../../../models/api/oauthClientModel';
import {StyledEditorMain, StyledEditorWrapper} from '../../editors/commons/editorCommons';
import {StyledEditorSidebarWrapperDiv} from '../../editors/expressions/sidebarBox';
import {ResourceEditorFooter} from '../commons/resourceEditorFooter';

/*
 * Props.
 */

interface OauthClientEditorSkeletonProps {
  oauthClient?: OauthClientModel;
}

/*
 * Component.
 */

export const OauthClientEditorSkeleton: FC<OauthClientEditorSkeletonProps> = (props) => {
  const {oauthClient} = props;

  return (
    <>
      <StyledEditorMain>
        <StyledEditorWrapper>
          <Skeleton width="150px" height="16px" />
        </StyledEditorWrapper>
        <StyledEditorSidebarWrapperDiv>
          <Skeleton
            height="290px"
            width="268px"
            scheme={SkeletonColorSchemesEnum.GREY10}
            borderRadius="14px"
          />
        </StyledEditorSidebarWrapperDiv>
      </StyledEditorMain>
      <ResourceEditorFooter
        isEditing={!isUndefined(oauthClient)}
        onSave={noop}
        onCancel={noop}
        createLabel={<Trans id="oauthClient-editor-footer-create">Create OAuth client</Trans>}
      />
    </>
  );
};
